<!--suppress ALL -->
<template>
  <div>
    <div class="page case-detail__content">
      <div class="padding15 bg-content m-b-24">
        <div class="m-b-24">
          <el-button type="primary" size="small" @click="addVisable" v-if="this.$hasPerm('H001&01')">添加录音员</el-button>
        </div>
        <div class="bg-content padding15">
          <el-form size="small" label-width="50px" ref="searchRef">
            <el-row :gutter="24">
              <el-col :span="8">
                <el-form-item label="姓名" label-width="140px">
                  <el-input v-model="searchReq.phone" placeholder="请输入查询条件"/>
                </el-form-item>
              </el-col>
              <el-col :span="4" :offset="0">
                <div class="text right">
                  <el-button type="primary" size="small" plain @click="getList();"><i class="fa fa-search"></i> 搜索</el-button>
                  <el-button size="small" @click="searchReq.name = null;">重置</el-button>
                </div>
              </el-col>
            </el-row>
          </el-form>
        </div>
        <div class="padding15 bg-content">
          <el-table size="small" :data="recorderlist">
            <el-table-column fixed property="name"  label="名字" align="center"/>
            <el-table-column fixed property="supplierName"  label="类型" align="center"/>
            <el-table-column fixed property="recorderNo"  label="编码" align="center"/>
            <el-table-column fixed property="gender"  label="性别" align="center"/>
            <el-table-column fixed property="speechRate"  label="语速" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.speechRate">{{scope.row.speechRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="pitchRate"  label="语调" align="center">
              <template slot-scope="scope">
                <span v-if="scope.row.pitchRate">{{scope.row.pitchRate}}</span>
                <span v-else>--</span>
              </template>
            </el-table-column>
            <el-table-column fixed property="status"  label="状态" align="center">
              <template slot-scope="scope">
                <el-tag type="success" v-if="scope.row.status === 1">开启</el-tag>
                <el-tag type="danger" v-else>关闭</el-tag>
              </template>
            </el-table-column>
            <el-table-column fixed property="createTime" label="添加时间"  align="center"/>
            <el-table-column fixed label="操作" align="center">
              <template slot-scope="scope">
                <el-button type="text" size="small" @click="updateVisiable(scope.row)"><i class="el-icon-edit-outline"></i>&nbsp;编辑</el-button>
                <el-button type="text" size="small" @click="remove(scope.row.id)"><i class="el-icon-delete"></i>&nbsp;删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <!-- 添加/编辑录音员 -->
        <el-dialog :title="title" :visible.sync="addOrUpdateVisible" width="30%" center>
          <div>
            <el-form size="small" label-width="140px">
              <el-form-item label="名字">
                <el-input placeholder="请输入录音员名字" v-model="addReq.name" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="类型">
                <el-select v-model="addReq.supplierCode" filterable  placeholder="请选择" style="width: 80%;" onchange="supplierCodeChange">
                  <el-option
                    v-for="item in supplierCodeOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="编码">
                <el-input placeholder="请输入录音编码" v-model="addReq.recorderNo" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="性别">
                <el-select v-model="addReq.gender" filterable  placeholder="请选择" style="width: 80%;">
                  <el-option
                    v-for="item in genderList"
                    :key="item.value"
                    :label="item.value"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="语速">
                <el-input placeholder="请输入录音语速，范围是-500~500" v-model="addReq.speechRate" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="语调">
                <el-input placeholder="请输入录音语调，范围是-500~500" v-model="addReq.pitchRate" style="width: 80%;"/>
              </el-form-item>
              <el-form-item label="音频模版" v-model="addReq.templatePath" v-if="addReq.supplierCode === 1004">
                <template>
                  <span v-if="addReq.templatePath" >
                    <el-button icon="el-icon-service" @click="showButton(addReq)" v-if="addReq.showAddress === false" style="width: 80%;">{{ addReq.templateOriginalName }}</el-button>
                    <div v-if="addReq.showAddress === true" v-loading="addReq.voiceLoading" class="audio" :id="'myAudio'+addReq.id" element-loading-spinner="el-icon-loading"
                      element-loading-background="#F5F7FA" style="height: 30px;width: 180px;outline: none;">
                    </div>
                  </span>
                  <span v-else>--</span>
                </template>
              </el-form-item>
              <el-form-item label="" v-model="addReq.templatePath" v-if="addReq.supplierCode === 1004">
                <!-- 音频文件上传 -->
                <el-upload
                  class="upload-demo"
                  ref="upload"
                  action='#'
                  multiple
                  :limit="1"
                  :on-change="fileChanged"
                  accept=".wav,.mp3,.m4a"
                  :show-file-list="false"
                  :auto-upload="false"
                  :file-list="fileList.length===0?[]:fileList"
                >
                  <el-button type="primary" icon="el-icon-upload" @click="upload()">
                    点击上传音频
                  </el-button>
                  <div style="display: inline-block; margin-left: 10px;">
                    <el-tooltip class="item" effect="light" placement="right">
                      <div slot="content">
                        只能上传.wav|.mp3|.m4a格式文件，且不超过20MB
                      </div>
                      <i class="el-icon-question"></i>
                    </el-tooltip>
                  </div>
                </el-upload>
              </el-form-item>
              <el-form-item label="状态">
                <el-switch v-model="addReq.status" :active-value="1" :inactive-value="0"/>
              </el-form-item>
            </el-form>
          </div>
          <div slot="footer" class="dialog-footer">
            <el-button @click="addOrUpdateVisible = false" size="small">取 消</el-button>
            <el-button type="primary" size="small" @click="updateOrInsert">保存</el-button>
          </div>
          <!-- 进度条 -->
          <el-progress
            v-if="progressVisible"
            :percentage="progressPercent"
            style="margin-top: 20px;"
          ></el-progress>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      searchReq: {
        name: null
      },
      recorderlist: [],
      addReq: {
        id: null,
        gender: null,
        name: null,
        status: null,
        recorderNo: null,
        speechRate: null,
        pitchRate: null,
        supplierCode: null,
        templatePath: null,
        templatePathTem: null,
        templateOriginalName: null,
        showAddress: false
      },
      genderList: [
        {
          value: '男'
        },
        {
          value: '女'
        }
      ],
      supplierCodeOption: [
        {
          value: 1000,
          label: 'XF'
        },
        {
          value: 1001,
          label: 'AL'
        },
        {
          value: 1002,
          label: 'WR'
        },
        {
          value: 1003,
          label: 'HS'
        },
        {
          value: 1004,
          label: 'ZJ'
        }
      ],
      addOrUpdateVisible: false,
      title: null,
      fileList: [],
      progressVisible: false,
      progressPercent: 0
    };
  },
  methods: {
    addVisable() {
      this.title = '添加录音员';
      this.addReq.id = null;
      this.addReq.gender = null;
      this.addReq.name = null;
      this.addReq.status = null;
      this.addReq.recorderNo = null;
      this.addReq.speechRate = null;
      this.addReq.pitchRate = null;
      this.addReq.supplierCode = null;
      this.addReq.templatePath = null;
      this.addReq.templateOriginalName = null;
      this.addOrUpdateVisible = true;
      this.addReq.showAddress = false;
    },
    updateVisiable(row) {
      console.warn(row);
      this.title = '编辑录音员';
      console.warn(row);
      this.addReq.id = row.id;
      this.addReq.gender = row.gender;
      this.addReq.name = row.name;
      this.addReq.status = row.status;
      this.addReq.recorderNo = row.recorderNo;
      this.addReq.speechRate = row.speechRate;
      this.addReq.pitchRate = row.pitchRate;
      this.addReq.supplierCode = row.supplierCode;
      this.addReq.templatePath = row.templatePath;
      this.addReq.templateOriginalName = row.templateOriginalName;
      this.addOrUpdateVisible = true;
      this.addReq.showAddress = false;
    },
    updateOrInsert() {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.$ajax({
        prompt: true,
        method: 'POST',
        url: '/recorder/updateOrInsert',
        data: this.addReq
      }).then(() => {
        loading.close();
        this.getList();
        this.addOrUpdateVisible = false;
      }).catch(() => {
        loading.close();
        this.addOrUpdateVisible = true;
      });
    },
    remove(userId) {
      this.$confirm('您确定要删除该录音员吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$ajax({
          prompt: true,
          method: 'DELETE',
          url: `/recorder/remove/${userId}`
        }).then(() => {
          // 刷新
          this.getList();
        });
      });
    },
    getList() {
      this.$ajax({
        method: 'POST',
        url: '/recorder/list',
        data: this.searchReq
      }).then((res) => {
        this.recorderlist = res.data;
      });
    },
    // 上传音频
    fileChanged(file, fileList) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      });
      this.addReq.templatePathTem = null;
      this.addReq.templateOriginalName = null;
      this.addReq.templatePath = null;
      this.fileList = fileList;
      const FileExt = file.name.replace(/.+\./, '').toLowerCase();
      const wavFlag = ['wav'].includes(FileExt);
      const mp3Flag = ['mp3'].includes(FileExt);
      const m4aFlag = ['m4a'].includes(FileExt);
      const isLt10M = file.size / 1024 / 1024 < 20;
      if (!wavFlag && !mp3Flag && !m4aFlag) {
        this.$message.error('文件格式错误请重新上传!');
        this.fileList = [];
        loading.close();
      }
      if (!isLt10M) {
        this.$message.error('上传的文件大小不能超过 20MB!');
        this.fileList = [];
        loading.close();
      }
      const formData = new FormData();
      formData.append('file', this.fileList[0].raw);
      formData.append('type', 3);
      if ((wavFlag || mp3Flag || m4aFlag) && isLt10M) {
        this.$ajax({
          url: '/scene/recordUpload',
          method: 'POST',
          prompt: true,
          contentType: 'multipart/form-data',
          data: formData
        }).then((res) => {
          if (res.data) {
            const uploadedFile = res.data[0];
            const fileName = file.name.substring(file.name.lastIndexOf('/') + 1);
            const ai = {
              value: uploadedFile,
              label: fileName
            };
            this.fileList.push(ai);
            this.addReq.templatePathTem = ai.value;
            this.addReq.templateOriginalName = ai.label;
            this.addReq.templatePath = ai.value;
            this.addReq.showAddress = false;
          }
          loading.close();
        }).catch(() => {
          loading.close();
        });
      }
      return (wavFlag || mp3Flag || m4aFlag) && isLt10M;
    },
    upload() {
      // 先清空之前的文件
      this.fileList = [];
      this.$refs.upload.clearFiles();
    },
    showButton(scope) {
      scope.showAddress = true;
      this.auditionVoice(scope, scope.id);
    },
    // 录音试听
    auditionVoice(row, index) {
      this.$set(row, 'voiceLoading', true);
      this.$downloadVoice({
        url: '/scene/getRecord',
        method: 'GET',
        responseType: 'blob',
        params: { 'address': row.templatePath }
      }).then((re) => {
        const blob = new Blob([re.data], { type: 'audio/wav' });
        const href = window.URL.createObjectURL(blob);
        const frameAudio = document.createElement('audio');
        frameAudio.controls = true;
        frameAudio.src = href;
        frameAudio.style = 'height: 30px;width: 180px;outline: none;';
        const bodyFa = document.getElementById(`myAudio${index}`);
        bodyFa.appendChild(frameAudio);
      }).finally(() => {
        this.$set(row, 'voiceLoading', false);
      });
    }
  },
  mounted() {
    this.getList();
  }
};
</script>



// WEBPACK FOOTER //
// src/page/main/recorder/index.vue